var React = require('react');

function K1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"K1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"20.04 49.63 59.72 0 0 2.34 1.04 28.95 20.04 49.63","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"0.62 13.47 0.62 81.21 31.97 81.21 63.18 81.21 0.62 13.47","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

K1.defaultProps = {"viewBox":"0 0 63.18 81.21"};

module.exports = K1;

K1.default = K1;
